import { PermissionItem } from "../../utils/lead-utils";

interface Props {
    permissions:PermissionItem[]
}

export default function DefaultPermissions({ permissions }:Props) {
    return (
        <>
           

            <div className="mt-2 p-3 bg-[#f2fbff]  rounded-xl">
                <div className="flex flex-wrap gap-2">
                    {permissions.map(({ label, icon: Icon }) => (
                        <div
                            key={label}
                            className="flex items-center gap-1.5 px-2.5 py-1.5 bg-white border rounded-md text-sm"
                        >
                            <Icon size={14} className="text-blue-600" />
                            <span className="text-gray-800">{label}</span>
                            <span className="w-1.5 h-1.5 rounded-full bg-green-500 ml-1" />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
